import { defineAgenda, param } from '@/shared/navigation/core';

/**
 * Agenda detailu trasy — jeden formulář pro založení i editaci. Bez `stationChainId` = založení,
 * s `stationChainId` = editace. Otevírá se jako modální vrstva nad seznamem tras.
 */
export const stationChainDetailAgenda = defineAgenda({
  id: 'app.products.station-chain-detail',
  path: 'app/products/station-chain',
  open: {
    stationChainId: param.string().optional(),
  },
  title: 'Trasa',
  icon: 'route',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
